"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var prodEnv = function () { return ({
    NAME: 'prod',
    BOOKSTORE_ROUTER_BASE_NAME: '/',
    ASSET_ROOT: '/assets/',
    BUILDER_HOST: 'https://builder.rowan.nyc/',
    BUILDER_UI_HOST: 'https://builder-ui.rowan.nyc/',
    PLATFORM: 'web',
    NATIVE_APPLICATION: false,
    READER_BASE_URL: 'https://builder-assets.rowan.nyc/reader-v-2',
    READER_URL: 'https://reader.rowan.nyc/',
    RUCKSACK_CALLBACK: 'https://reader.rowan.nyc/',
    RUCKSACK_CLIENT_ID: '8c266c5ced4d6f5e1b274194e0656f2eba6992b5503c18f8fe45886700847986',
    RUCKSACK_HOST: 'https://rucksack.rowan.nyc',
    RUCKSACK_URL: 'https://rucksack.rowan.nyc/',
    RUCKSACK_SECRET: '9bb230f01e84491d5d8bdb78f70b03a7bb7a4db9bc71d0cabadd69b2a5f1f4a7',
    BOOKSHELF_URL: 'https://app.rowan.nyc',
    BOOKSHELF_AUTH_URL: 'https://app.rowan.nyc/loadAuthToken.html',
    FEATURE_FLAG_URL: '/feature-flags.json',
    API_GATEWAY_URL: 'https://gateway.rowan.nyc/',
    SECURE_COOKIES: true,
    COOKIE_DOMAIN: 'rowan.nyc'
}); };
exports.default = prodEnv;
